import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-header justify-content-center mt-2" }
const _hoisted_2 = { class: "modal-body ml-2" }
const _hoisted_3 = { class: "upload-file-area mt-2" }
const _hoisted_4 = {
  id: "upload-file-wrapper",
  class: "v-theme--light mt-2",
  style: {"width":"80%"}
}
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = {
  class: "mt-2",
  style: {"color":"#3c8dbc"}
}
const _hoisted_7 = { class: "upload-file-results mt-2" }
const _hoisted_8 = { style: {"color":"#3c763d","margin-bottom":"0px important!"} }
const _hoisted_9 = { style: {"color":"#3c763d","margin-bottom":"0px important!"} }
const _hoisted_10 = {
  class: "mt-1",
  style: {"color":"#a94442"}
}
const _hoisted_11 = { class: "d-flex justify-content-end m-3 mt-2" }

import { ref, watch } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';
import { useAuth } from '@/services/user/Auth0UserProvider';
import { ObjectToFormData, firstFile } from '@/services/functions';
import { GDialog } from 'gitart-vue-dialog';
import outputContentsMessage from '@/types/apiresponses/jobStatusOutputContentsMessage';
import i18n from '@/lang/i18n';

type Props = {
  modalState: boolean;
  title: string;
  modalMaxWidth?: string;
  uploadBtnClass?: string;
  uploadBtnName?: string;
  closeBtnName?: string;
  closeBtnClass?: string;
  uploadFileText?: string;
  type: string;
  operationOfficeId?: number;
  notes?: string;
  sampleFileDownloadText?: string;
  templateCsvFileType?: string;
  uploadableExtension?: string;
};

type Emits = {
  (e: 'closeModal', value: boolean): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadModal',
  props: {
    modalState: { type: Boolean, default: false },
    title: {},
    modalMaxWidth: { default: '50%' },
    uploadBtnClass: {},
    uploadBtnName: { default: i18n.global.t('pages.common.button.import') },
    closeBtnName: { default: i18n.global.t('pages.common.button.close') },
    closeBtnClass: {},
    uploadFileText: { default: i18n.global.t('pages.common.labels.inputFile') },
    type: {},
    operationOfficeId: {},
    notes: { default: i18n.global.t('pages.common.notes.csvImportFormat') },
    sampleFileDownloadText: { default: i18n.global.t('pages.common.button.sampleCsvFileDownload') },
    templateCsvFileType: {},
    uploadableExtension: { default: 'text/csv' }
  },
  emits: ["closeModal"],
  setup(__props: any, { emit: __emit }) {

const { loginWithRedirect } = useAuth();
const state = ref<boolean>(false);
const uploading = ref<boolean>(false);
const uploadFileResults = ref<outputContentsMessage>({});
const validationMessages = ref<string[]>([]);
const selectedFile = ref<File | File[] | null>([]);

const props = __props;

watch(
  () => props.modalState,
  (value: boolean) => {
    state.value = value;
    if (state.value) return;

    uploadFileResults.value = {};
    validationMessages.value = [];
    selectedFile.value = [];
  }
);

const emit = __emit;

const uploadFile = () => {
  const file = firstFile(selectedFile.value);
  if (!file) {
    validationMessages.value = ['選択してください。'];
    return;
  }
  uploading.value = true;
  uploadFileResults.value = {};
  validationMessages.value = [];

  const params = {
    operation_office_id: props.operationOfficeId,
    type: props.type,
  };

  let formData = new FormData();
  formData.append('file', file);
  ObjectToFormData(params, formData, '');

  Api()
    .createJobStatus(formData)
    .then((data) => {
      pollingJobStatus(data.id);
    })
    .catch((error) => {
      const res = error.response;
      switch (res.status) {
        case 401:
          loginWithRedirect({ appState: { targetUrl: location.pathname } });
          break;
        case 403:
          location.reload();
          break;
        case 422:
          validationMessages.value = res.data.message['file'];
      }
      uploading.value = false;
    });
};

const pollingJobStatus = (id: number) => {
  const interval = setInterval(() => {
    Api()
      .getJobStatus(id)
      .then((res) => {
        if (res.status == 'completed') {
          uploadFileResults.value = res?.output_contents?.message ?? {};
          clearInterval(interval);
          uploading.value = false;
        }
        if (res.status == 'failed') {
          alert(res?.output_contents?.message);
          clearInterval(interval);
          uploading.value = false;
        }
        clickClearButton();
      });
  }, 3000);
};

const download = () => {
  if (!props.templateCsvFileType) return;

  Api().csvTemplatefileDownload(props.templateCsvFileType);
};

const close = () => {
  let isReacquire = false;
  const successMsg = uploadFileResults.value?.['success'];
  const updatedSuccessMsg = uploadFileResults.value?.['updatedSuccess'];

  if ((successMsg || updatedSuccessMsg)
    && (Number(successMsg.split(' ')[1]) >= 1 || Number(updatedSuccessMsg?.split(' ')[1]) >= 1)
  ) {
    isReacquire = true;
  }
  emit('closeModal', isReacquire);
};

const clickClearButton = () => {
  const clearBtn = document
    .getElementById('upload-file-wrapper')
    ?.getElementsByClassName('v-field__clearable')[0]
    ?.children[0] as HTMLElement | null;

  if (clearBtn) clearBtn.click();
};

return (_ctx: any,_cache: any) => {
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (state.value)
    ? (_openBlock(), _createBlock(_unref(GDialog), {
        key: 0,
        modelValue: state.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state).value = $event)),
        "max-width": __props.modalMaxWidth,
        transition: "custom-from-bottom-transition",
        persistent: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("label", null, _toDisplayString(__props.title), 1)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, _toDisplayString(__props.uploadFileText), 1),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_file_input, {
                  label: "ファイルを選択",
                  modelValue: selectedFile.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedFile).value = $event)),
                  "truncate-length": "15",
                  accept: __props.uploadableExtension,
                  "error-messages": validationMessages.value
                }, null, 8, ["modelValue", "accept", "error-messages"])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.notes), 1),
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", {
                class: "sample-file-download",
                onClick: download
              }, _toDisplayString(__props.sampleFileDownloadText), 1)
            ], 512), [
              [_vShow, !!__props.templateCsvFileType]
            ]),
            _createElementVNode("div", null, [
              _renderSlot(_ctx.$slots, "supplementary-message")
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(uploadFileResults.value?.['success']), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(uploadFileResults.value?.['updatedSuccess']), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(uploadFileResults.value?.['fail']), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadFileResults.value?.['errors'] ?? {}, (errors, msg) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: msg,
                  style: {"color":"#a94442"}
                }, _toDisplayString(msg) + " 行番号:" + _toDisplayString(errors?.join(',')), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_v_btn, {
                class: _normalizeClass([__props.closeBtnClass, "close-btn"]),
                onClick: close,
                disabled: uploading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.closeBtnName), 1)
                ]),
                _: 1
              }, 8, ["class", "disabled"]),
              _createVNode(_component_v_btn, {
                class: _normalizeClass([__props.uploadBtnClass, "file-upload-btn"]),
                onClick: uploadFile,
                loading: uploading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.uploadBtnName), 1)
                ]),
                _: 1
              }, 8, ["class", "loading"])
            ])
          ])
        ]),
        _: 3
      }, 8, ["modelValue", "max-width"]))
    : _createCommentVNode("", true)
}
}

})